import {useEffect} from "react";

export function scrollToTop(
  containerId = "main-section-container",
  behavior: ScrollBehavior = "smooth"
) {
  const container = document.getElementById(containerId);
  if (container) {
    container.scrollTo({top: 0, behavior});
  } else {
    window.scrollTo({top: 0, behavior});
  }
}

export function useScrollToTopOnChange(
  dependency: any,
  options?: {
    containerId?: string;
    behavior?: ScrollBehavior;
  }
) {
  useEffect(() => {
    const {containerId = "main-section-container", behavior = "smooth"} = options || {};
    const container = document.getElementById(containerId);
    if (container) {
      container.scrollTo({top: 0, behavior});
    } else {
      window.scrollTo({top: 0, behavior});
    }
  }, [dependency, options]);
}
